const system = {
    state: {
        currentTabbar: 0
    },
    mutations: {},
    actions:{}
}

export default system